/**
 * Listings Module
 * 
 * Components and utilities for displaying property listings with full
 * Route Royal Listings API integration.
 */

// Components
export { ListingCard } from './ListingCard';
export type { ListingCardProps } from './ListingCard';

export { ListingGrid, ListingGridSkeleton } from './ListingGrid';
export type { ListingGridProps } from './ListingGrid';

export { ListingFilters, applyListingFilters, defaultFilters } from './ListingFilters';
export type { ListingFiltersProps, ListingFiltersState } from './ListingFilters';

export { 
  FeaturedBadge, 
  FeaturedBadgeFeatured,
  FeaturedBadgeHot,
  FeaturedBadgeNew,
  FeaturedBadgeExclusive,
  FeaturedBadgePremium,
  FeaturedBadgePriceReduced,
  FeaturedBadgeLuxury,
} from './FeaturedBadge';
export type { FeaturedBadgeProps } from './FeaturedBadge';

// Types and utilities
export {
  transformListingToCardData,
  getListingTypeLabel,
  getListingTypeColor,
  getListingStatusLabel,
  getListingStatusColor,
  formatListingPrice,
  formatAuctionGuidePrice,
} from './types';
export type { ListingCardData } from './types';
